import { Box, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { FontFamily } from '@common/theming/Fonts';
import currency from '@common/utility/currency';
import { formatDate } from '@common/utility/datetime';
import { MSFee, MSFees, MSFeeTotals } from '@services/appsync/types';
import React, { useMemo } from 'react';
import { CURRENCY_OPTIONS } from '../../constants';
import { useStatementViewModel } from '../../models/StatementViewModel';

export const Fees: React.FC = () => {
  const statementViewModel = useStatementViewModel();

  const fees: MSFees = useMemo(() => {
    const fees = statementViewModel.statement?.activity.fees;

    const items: MSFee[] =
      fees?.items?.map((fee) => ({
        __typename: 'MSFee',
        date: formatDate(new Date(`${fee.date}T00:00:00`), 'MMMM DD, YYYY'),
        description: fee.description,
        fee_amount: fee.fee_amount ? currency.format(fee.fee_amount, CURRENCY_OPTIONS) : '',
      })) ?? [];

    const totals: MSFeeTotals = {
      __typename: 'MSFeeTotals',
      fee_amount: fees?.totals.fee_amount ? currency.format(fees.totals.fee_amount, CURRENCY_OPTIONS) : '',
    };

    return { __typename: 'MSFees', items, totals };
  }, [statementViewModel.statement?.activity.fees]);

  if (!fees || fees.items?.length === 0) return null;

  return (
    <Box w="full">
      <TableContainer>
        <Table px={'0px'} layout="fixed">
          <Thead>
            <Tr>
              <Td
                pl={'0px'}
                borderBottomStyle="none"
                fontSize="16px"
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                colSpan={6}>
                Fees
              </Td>
            </Tr>
            <Tr py="6px" borderBottom={'2px solid black'}>
              <Th
                className="statement-table-header"
                lineHeight={1}
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                fontWeight="normal"
                pl={'0px'}
                color="black">
                Date
              </Th>
              <Th
                className="statement-table-header"
                colSpan={4}
                lineHeight={1}
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                fontWeight="normal"
                color="black">
                Type
              </Th>

              <Th
                className="statement-table-header"
                lineHeight={1}
                fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                fontWeight="normal"
                color="black">
                Total Amount
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {fees.items?.map((item, i) => (
              <Tr py="6px" key={`holding-${i}`}>
                <Td pl="4px">{item.date}</Td>
                <Td colSpan={4}>{item.description}</Td>
                <Td>{item.fee_amount}</Td>
              </Tr>
            ))}
            <Tr py="6px" backgroundColor="gray.50">
              <Td pl="4px" colSpan={5} fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
                Total
              </Td>
              <Td fontFamily={FontFamily.HELVETICA_NOW_BOLD}>{fees.totals.fee_amount}</Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};
